/* eslint-disable max-lines */
/* eslint-disable max-len */
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { MedicalTypeIds } from "../../models";
import * as questionIds from "../../questions/questionIds";

const enableNewNightWorkerQuestions = getFeatureToggles()[FeatureToggleNames.EnableNewNightWorkerQuestions];

export const medicalContinuedQuestions = [
    {
        id: questionIds.HeartProblems,
        questionText: "Heart problems, eg - heart attack, heart disease, heart implants, palpitations, angina, chest pain",
        medicalTypes: [
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.HeartProblemsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.HighBloodPressure,
        questionText: "High blood pressure",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.HighBloodPressureFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.StokeOrTransientIschaemicAttacks,
        questionText: "Stroke, or Transient Ischaemic Attacks (TIAs)?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.StokeOrTransientIschaemicAttacksFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.HeadInjuryRequiringHospital,
        questionText: "Head injury requiring brain surgery or admission to hospital?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.HeadInjuryRequiringHospitalFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.RespiratoryDisease,
        questionText: "Respiratory disease e.g. asthma, bronchitis, Pneumonia, TB (Tuberculosis)",
        medicalTypes: [
            MedicalTypeIds.Skin,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.LAAWorker,
            MedicalTypeIds.SkinLevel1,
            MedicalTypeIds.SkinAssessmentLevel2
        ]
    },
    {
        id: questionIds.RespiratoryDiseaseFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.Skin,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.SkinLevel1,
            MedicalTypeIds.SkinAssessmentLevel2
        ]
    },
    {
        id: questionIds.PeripheralVascularDisease,
        questionText: "Peripheral Vascular Disease e.g. Raynaud's Disease, leg cramps, poor circulation",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.PeripheralVascularDiseaseFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.BloodCoagulationDisorders,
        questionText: "Blood/coagulation Disorders e.g. Blood cancer, Haemophilia, Anaemia, thrombosis/clot",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.BloodCoagulationDisordersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.MetabolicDisorders,
        questionText: "Metabolic disorders e.g. thyroid problems Diabetes",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.MetabolicDisordersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.GastricIntestinalProblems,
        questionText: "Gastric/intestinal problems including stomach ulcer, acid reflux, Crohn's Disease, Diverticulitis",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.GastricIntestinalProblemsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.HistoryOfBlackouts,
        questionText: "History of blackouts, loss of consciousness, fainting",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.HistoryOfBlackoutsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.SleepDisorders,
        questionText: "Sleep disorders eg - excessive sleepiness, sleep apnoea",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.SleepDisordersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.MusculoskeltalDisorders,
        questionText: "Musculoskeletal disorders e.g. arthritis, ankylosing spondylitis, Fibromyalgia, Lupus, Gout",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.MusculoskeltalDisordersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.JointProblems,
        questionText: "Joint pain/problems e.g. back, knee, shoulder, ankle",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.JointProblemsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.NeurologicalDisorders,
        questionText: "Do you have any history of neurological disorders? e.g. Epilepsy, blackouts or dizziness, vertigo",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.NeurologicalDisordersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.NeurologicalDisordersMedication,
        questionText: "Are you on any medication",
        medicalTypes: [
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.NeurologicalDisordersLastEpisode,
        questionText: "When was your last episode",
        medicalTypes: [
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.ConditionsThatAffectBalance,
        questionText: "Do you have a history of any condition that affects balance e.g. Meniere's Disease",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.Headaches,
        questionText: "Headaches / migraines",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.HeadachesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.HearingDifficulty,
        questionText: "Hearing Difficulty",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.HearingDifficultyFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.DifficultyWithVision,
        questionText: "Difficulty with vision",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.DifficultyWithVisionFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.Claustophobia,
        questionText: "Claustrophobia",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.ClaustophobiaFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.SkinDisorders,
        questionText: "Skin disorders or disease",
        medicalTypes: [
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.FoodHandlerQuestionsOnly,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.SkinDisordersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            MedicalTypeIds.FoodHandlerQuestionsOnly,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.LackSenseOfSmell,
        questionText: "Lack of sense of smell",
        medicalTypes: [
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.LackSenseOfSmellFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.FearHeights,
        questionText: "Do you have a fear of heights?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.FearHeightsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.UnderlyingMentalHealthConditions,
        questionText: "Any underlying mental health conditions such as stress, depression, anxiety, bi polar.",
        medicalTypes: [
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.UnderlyingMentalHealthConditionsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.ImpairedAwareness,
        questionText: "Any impaired awareness or lacks in concentration?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.ImpairedAwarenessFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.StrictMedicationTimetable,
        questionText: "Any medical conditions that require medication to be taken on a strict timetable?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.StrictMedicationTimetableFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.MedicationSideEffects,
        questionText: "Are you taking any medication that causes drowsiness or have any other side effects?",
        medicalTypes: [
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.MedicationSideEffectsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.AlcoholDependency,
        questionText: "Any alcohol misuse or dependency?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.AlcoholDependencyFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.DrugDependency,
        questionText: "Any drug misuse or dependency?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.DrugDependencyFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.NonPrescribedDrugs,
        questionText: "Do you use any non-prescribed drugs?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.NonPrescribedDrugsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.MoreThan14UnitsAlcoholAWeek,
        questionText: "Do you regularly consume more than 14 units of alcohol a week?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.MoreThan14UnitsAlcoholAWeekFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.RetiredIllHealth,
        questionText: "Have you ever been retired on ill health?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.RetiredIllHealthFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.NotifyDvlaMedicalConditions,
        questionText: "Have you ever had to notify DVLA of any medical conditions?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.NotifyDvlaMedicalConditionsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.FieldForce,
        ]
    },
    {
        id: questionIds.WearGlasses,
        questionText: "Do you wear glasses?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.WearGlassesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.WearContactLenses,
        questionText: "Do you wear contact lenses?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.WearContactLensesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.ExaminedByVisionSpecialistOptician,
        questionText: "Have you ever been examined by a vision specialist, optician or other?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.ExaminedByVisionSpecialistOpticianFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.DifficultiesWithEyes,
        questionText: "Do you have any difficulties with your eyes?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.DifficultiesWithEyesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.ColourBlind,
        questionText: "Are you colour blind",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.ColourBlindFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork
        ]
    },
    {
        id: questionIds.SupportingDocuments,
        questionText: "Please upload any attachments or supporting information that may be useful, such as immunisation history, copies of any medical prescriptions or letters from GPs and Specialists",
        medicalTypes: [
            MedicalTypeIds.Skin,
            MedicalTypeIds.SkinFaceToFace,
            MedicalTypeIds.Audiometry,
            MedicalTypeIds.RespiratorySensitiser,
            MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1,
            MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1,
            MedicalTypeIds.HAVS,
            MedicalTypeIds.HAVSFaceToFace,
            MedicalTypeIds.IonisingRadiation,
            MedicalTypeIds.IonisingRadiationFaceToFace,
            MedicalTypeIds.BiologicalMonitoring,
            MedicalTypeIds.OtherSurveillance,
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.FoodHandlerQuestionsOnly,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.ManualHandlingMSKQuestionnaire,
            MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration,
            MedicalTypeIds.LAAWorker,
            MedicalTypeIds.FieldForce,
            MedicalTypeIds.SkinLevel1,
            MedicalTypeIds.SkinFaceToFaceLevel1,
            MedicalTypeIds.SkinAssessmentLevel2
        ]
    },
];
